import React, { useState, useContext } from "react";
import "./register.css";
import api, { API_URL, showAlert, AuthContext } from "./util/api";
import { Link, useNavigate } from "react-router-dom";

export default function Login() {

    const { login } = useContext(AuthContext);
    const navigate = useNavigate();

    const [form, setForm] = useState({

        email: "",

        password: "",

    });



    const [showPassword, setShowPassword] = useState(false);



    const [loading, setLoading] = useState(false);



    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };




    const submitForm = async (e) => {
        e.preventDefault();

      
        try {
            const formData = new FormData();
            setLoading(true);

            Object.keys(form).forEach(key => formData.append(key, form[key]));



            let response = await api.post(`${API_URL}/login`, formData, {
                headers: { "Content-Type": "multipart/form-data" },

            });

            if (response.data.status === "successful") {

                showAlert(
                    "success",
                    "Login Successful!",
                    "Login Successful!",
                    5000
                );

                login(response.data.token, response.data.data);
                navigate("/dashboard");


            } else {
                showAlert("error", "Login Failed", response.data.message, 5000);
            }

            setLoading(false);

        } catch (e) {
            showAlert("error", "Login Failed", `Your login failed. Please try again later. ${e.message}`, 5000);

            setLoading(false);
        }
    };

    return (
        <div className="conference-page">
            <section id="register" className="register-section">
                <div className="register-box">
                    <h2 style={{ color: "white" }}>Login</h2>

                    <form onSubmit={submitForm}>



                        <input
                            type="email"
                            name="email"
                            placeholder="Email Address"
                            value={form.email}
                            onChange={handleChange}
                            required
                        />



                        {/* PASSWORD */}
                        <div style={{ position: "relative" }}>
                            <input
                                type={showPassword ? "text" : "password"}
                                name="password"
                                placeholder="Password"
                                value={form.password}
                                onChange={handleChange}
                                required
                            />
                            <span
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                    position: "absolute",
                                    right: 10,
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                    fontSize: 12,
                                    color: "#fff"
                                }}
                            >
                                {showPassword ? "Hide" : "Show"}
                            </span>
                        </div>

                        {/* CONFIRM PASSWORD */}





                        <button disabled={loading} type="submit">
                            {loading ? "Loading..." : "Login"}
                        </button>

                    </form>

                    <p>Forgot password? <Link style={{ color: "white" }} to="/forgot_password">Reset here</Link></p>
                </div>
            </section>
        </div>
    );
}